module.exports = __webpack_public_path__ + "static/media/duplicate.5039c325.svg";